/* src/components/Login.svelte generated by Svelte v3.55.0 */
import {
	SvelteComponentDev,
	add_location,
	append_hydration_dev,
	attr_dev,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach_dev,
	dispatch_dev,
	element,
	empty,
	init,
	insert_hydration_dev,
	listen_dev,
	noop,
	run_all,
	safe_not_equal,
	space,
	text,
	validate_slots
} from "../../web_modules/svelte/internal.js";

const file = "src/components/Login.svelte";

// (19:0) {#if loginFormIsOpened}
function create_if_block(ctx) {
	let section;
	let div5;
	let header;
	let h2;
	let t0;
	let t1;
	let div4;
	let div1;
	let label0;
	let t2;
	let t3;
	let div0;
	let input0;
	let t4;
	let div3;
	let label1;
	let t5;
	let t6;
	let div2;
	let input1;
	let t7;
	let footer;
	let button0;
	let t8;
	let t9;
	let button1;
	let t10;
	let t11;
	let div6;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			section = element("section");
			div5 = element("div");
			header = element("header");
			h2 = element("h2");
			t0 = text("Log In");
			t1 = space();
			div4 = element("div");
			div1 = element("div");
			label0 = element("label");
			t2 = text("Username");
			t3 = space();
			div0 = element("div");
			input0 = element("input");
			t4 = space();
			div3 = element("div");
			label1 = element("label");
			t5 = text("Password");
			t6 = space();
			div2 = element("div");
			input1 = element("input");
			t7 = space();
			footer = element("footer");
			button0 = element("button");
			t8 = text("Cancel");
			t9 = space();
			button1 = element("button");
			t10 = text("Log In");
			t11 = space();
			div6 = element("div");
			this.h();
		},
		l: function claim(nodes) {
			section = claim_element(nodes, "SECTION", {
				role: true,
				tabindex: true,
				"aria-labelledby": true,
				"aria-modal": true,
				"aria-describedby": true,
				class: true
			});

			var section_nodes = children(section);
			div5 = claim_element(section_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			header = claim_element(div5_nodes, "HEADER", { class: true });
			var header_nodes = children(header);
			h2 = claim_element(header_nodes, "H2", { id: true, class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, "Log In");
			h2_nodes.forEach(detach_dev);
			header_nodes.forEach(detach_dev);
			t1 = claim_space(div5_nodes);
			div4 = claim_element(div5_nodes, "DIV", { class: true, id: true });
			var div4_nodes = children(div4);
			div1 = claim_element(div4_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			label0 = claim_element(div1_nodes, "LABEL", { class: true });
			var label0_nodes = children(label0);
			t2 = claim_text(label0_nodes, "Username");
			label0_nodes.forEach(detach_dev);
			t3 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			input0 = claim_element(div0_nodes, "INPUT", { type: true, class: true, id: true });
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			t4 = claim_space(div4_nodes);
			div3 = claim_element(div4_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			label1 = claim_element(div3_nodes, "LABEL", { class: true });
			var label1_nodes = children(label1);
			t5 = claim_text(label1_nodes, "Password");
			label1_nodes.forEach(detach_dev);
			t6 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			input1 = claim_element(div2_nodes, "INPUT", { type: true, class: true });
			div2_nodes.forEach(detach_dev);
			div3_nodes.forEach(detach_dev);
			div4_nodes.forEach(detach_dev);
			t7 = claim_space(div5_nodes);
			footer = claim_element(div5_nodes, "FOOTER", { class: true });
			var footer_nodes = children(footer);
			button0 = claim_element(footer_nodes, "BUTTON", { class: true });
			var button0_nodes = children(button0);
			t8 = claim_text(button0_nodes, "Cancel");
			button0_nodes.forEach(detach_dev);
			t9 = claim_space(footer_nodes);
			button1 = claim_element(footer_nodes, "BUTTON", { id: true, class: true });
			var button1_nodes = children(button1);
			t10 = claim_text(button1_nodes, "Log In");
			button1_nodes.forEach(detach_dev);
			footer_nodes.forEach(detach_dev);
			div5_nodes.forEach(detach_dev);
			section_nodes.forEach(detach_dev);
			t11 = claim_space(nodes);
			div6 = claim_element(nodes, "DIV", { class: true });
			children(div6).forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(h2, "id", "modal-heading-01");
			attr_dev(h2, "class", "slds-modal__title slds-hyphenate");
			add_location(h2, file, 23, 8, 631);
			attr_dev(header, "class", "slds-modal__header");
			add_location(header, file, 22, 6, 587);
			attr_dev(label0, "class", "slds-form-element__label");
			add_location(label0, file, 29, 10, 863);
			attr_dev(input0, "type", "text");
			attr_dev(input0, "class", "slds-input");
			attr_dev(input0, "id", "username");
			add_location(input0, file, 32, 12, 985);
			attr_dev(div0, "class", "slds-form-element__control");
			add_location(div0, file, 31, 10, 932);
			attr_dev(div1, "class", "slds-form-element");
			add_location(div1, file, 28, 8, 821);
			attr_dev(label1, "class", "slds-form-element__label");
			add_location(label1, file, 38, 10, 1125);
			attr_dev(input1, "type", "password");
			attr_dev(input1, "class", "slds-input");
			add_location(input1, file, 41, 12, 1247);
			attr_dev(div2, "class", "slds-form-element__control");
			add_location(div2, file, 40, 10, 1194);
			attr_dev(div3, "class", "slds-form-element");
			add_location(div3, file, 37, 8, 1083);
			attr_dev(div4, "class", "slds-modal__content slds-p-around_medium");
			attr_dev(div4, "id", "modal-content-id-1");
			add_location(div4, file, 25, 6, 732);
			attr_dev(button0, "class", "slds-button slds-button_neutral");
			add_location(button0, file, 48, 8, 1420);
			attr_dev(button1, "id", "login");
			attr_dev(button1, "class", "slds-button slds-button_brand");
			add_location(button1, file, 49, 8, 1515);
			attr_dev(footer, "class", "slds-modal__footer slds-modal__footer_directional");
			add_location(footer, file, 47, 6, 1345);
			attr_dev(div5, "class", "slds-modal__container");
			add_location(div5, file, 20, 4, 544);
			attr_dev(section, "role", "dialog");
			attr_dev(section, "tabindex", "-1");
			attr_dev(section, "aria-labelledby", "modal-heading-01");
			attr_dev(section, "aria-modal", "true");
			attr_dev(section, "aria-describedby", "modal-content-id-1");
			attr_dev(section, "class", "slds-modal slds-fade-in-open");
			add_location(section, file, 19, 2, 374);
			attr_dev(div6, "class", "slds-backdrop slds-backdrop_open");
			add_location(div6, file, 53, 2, 1649);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, section, anchor);
			append_hydration_dev(section, div5);
			append_hydration_dev(div5, header);
			append_hydration_dev(header, h2);
			append_hydration_dev(h2, t0);
			append_hydration_dev(div5, t1);
			append_hydration_dev(div5, div4);
			append_hydration_dev(div4, div1);
			append_hydration_dev(div1, label0);
			append_hydration_dev(label0, t2);
			append_hydration_dev(div1, t3);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, input0);
			append_hydration_dev(div4, t4);
			append_hydration_dev(div4, div3);
			append_hydration_dev(div3, label1);
			append_hydration_dev(label1, t5);
			append_hydration_dev(div3, t6);
			append_hydration_dev(div3, div2);
			append_hydration_dev(div2, input1);
			append_hydration_dev(div5, t7);
			append_hydration_dev(div5, footer);
			append_hydration_dev(footer, button0);
			append_hydration_dev(button0, t8);
			append_hydration_dev(footer, t9);
			append_hydration_dev(footer, button1);
			append_hydration_dev(button1, t10);
			insert_hydration_dev(target, t11, anchor);
			insert_hydration_dev(target, div6, anchor);

			if (!mounted) {
				dispose = [
					listen_dev(button0, "click", /*cancelLogin*/ ctx[1], false, false, false),
					listen_dev(button1, "click", /*doLogin*/ ctx[2], false, false, false)
				];

				mounted = true;
			}
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(section);
			if (detaching) detach_dev(t11);
			if (detaching) detach_dev(div6);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(19:0) {#if loginFormIsOpened}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*loginFormIsOpened*/ ctx[0] && create_if_block(ctx);

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l: function claim(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_hydration_dev(target, if_block_anchor, anchor);
		},
		p: function update(ctx, [dirty]) {
			if (/*loginFormIsOpened*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Login', slots, []);
	let { loginFormIsOpened = true } = $$props;
	let { username = "" } = $$props;
	let { isLoggedIn = false } = $$props;

	function cancelLogin() {
		$$invalidate(0, loginFormIsOpened = false);
		$$invalidate(4, isLoggedIn = false);
	}

	function doLogin() {
		$$invalidate(3, username = document.getElementById('username').value);
		$$invalidate(0, loginFormIsOpened = false);
		$$invalidate(4, isLoggedIn = true);
	}

	const writable_props = ['loginFormIsOpened', 'username', 'isLoggedIn'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Login> was created with unknown prop '${key}'`);
	});

	$$self.$$set = $$props => {
		if ('loginFormIsOpened' in $$props) $$invalidate(0, loginFormIsOpened = $$props.loginFormIsOpened);
		if ('username' in $$props) $$invalidate(3, username = $$props.username);
		if ('isLoggedIn' in $$props) $$invalidate(4, isLoggedIn = $$props.isLoggedIn);
	};

	$$self.$capture_state = () => ({
		loginFormIsOpened,
		username,
		isLoggedIn,
		cancelLogin,
		doLogin
	});

	$$self.$inject_state = $$props => {
		if ('loginFormIsOpened' in $$props) $$invalidate(0, loginFormIsOpened = $$props.loginFormIsOpened);
		if ('username' in $$props) $$invalidate(3, username = $$props.username);
		if ('isLoggedIn' in $$props) $$invalidate(4, isLoggedIn = $$props.isLoggedIn);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [loginFormIsOpened, cancelLogin, doLogin, username, isLoggedIn];
}

class Login extends SvelteComponentDev {
	constructor(options) {
		super(options);

		init(this, options, instance, create_fragment, safe_not_equal, {
			loginFormIsOpened: 0,
			username: 3,
			isLoggedIn: 4
		});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Login",
			options,
			id: create_fragment.name
		});
	}

	get loginFormIsOpened() {
		throw new Error("<Login>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set loginFormIsOpened(value) {
		throw new Error("<Login>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get username() {
		throw new Error("<Login>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set username(value) {
		throw new Error("<Login>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get isLoggedIn() {
		throw new Error("<Login>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set isLoggedIn(value) {
		throw new Error("<Login>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Login;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
//# sourceMappingURL=Login.js.map
